import request from '@/libs/request'
import { toast } from '../libs/utils'

// 获取全部报告和历史报告列表
export async function getHisAAllReportList (params) {
  let data = await request.postJson('/order/orderCheckReport/findPage', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({msg: data.message || '获取报告列表异常异常！'})
  }
}
// 获取预处理报告列表
export async function getProcessingReportList (params) {
  let data = await request.postJson('/order/orderCheckReport/preProcessingReportList', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({msg: data.message || '获取预处理报告列表异常！'})
  }
}
// 获取待领取报告列表
export async function getWaitingForTakeReportList (params) {
  let data = await request.postJson('/order/orderCheckReport/waitingForTakeReportList', params, false)
  if (window.location.href.indexOf('/ris/editReportList') === -1) return false
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({msg: data.message || '获取待领取报告列表异常！'})
  }
}
// 获取处理中报告列表
export async function getMyProcessingReportList (params) {
  let data = await request.postJson('/order/orderCheckReport/myProcessingReportList', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({msg: data.message || '获取待处理报告列表异常！'})
  }
}
// 获取我的已完成报告列表
export async function getMyFinishedReportList (params) {
  let data = await request.postJson('/order/orderCheckReport/myFinishedReportList', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({msg: data.message || '获取我的已完成报告列表异常！'})
  }
}
// 获取统计数据
export async function getStaticData (params) {
  let data = await request.postJson('/order/orderCheckReport/statisticReport', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  } else {
    toast({msg: data.message || '获取统计数据异常！'})
  }
}
